import { render, staticRenderFns } from "./MemberArea.vue?vue&type=template&id=2a33316a&scoped=true&"
import script from "./MemberArea.vue?vue&type=script&lang=js&"
export * from "./MemberArea.vue?vue&type=script&lang=js&"
import style0 from "./MemberArea.vue?vue&type=style&index=0&id=2a33316a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33316a",
  null
  
)

export default component.exports